import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useProductTypes() {
  const { token } = useContext(AuthContext);

  const [types, setTypes] = useState([]);
  const [subTypes, setSubTypes] = useState([]);
  const [subSubTypes, setSubSubTypes] = useState([]);

  useEffect(() => {
    if (!token) return;
    const loadProductTypes = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": token,
        };

        const res = await fetchWithInterceptor(
          "/api/product-types?isActive=true&limit=1000&includeParent=false",
          { headers }
        );

        if (res?.ok) {
          const { rows } = await res.json();

          setTypes(rows.filter((t) => t.level === "type"));
          setSubTypes(rows.filter((t) => t.level === "subtype"));
          setSubSubTypes(rows.filter((t) => t.level === "subsubtype"));
        } else if (res) {
          console.error("Failed to load product types:", res.status, res.statusText);
        }
      } catch (err) {
        console.error("Error loading product types:", err);
      }
    };

    loadProductTypes();
  }, [token]);

  return { types, subTypes, subSubTypes };
}